module.exports = "https://web-assets.ifttt.com/packs/media/shared/favicon-838eddab.png";